window.Shopify = window.Shopify || {};
if (!window.Shopify.formatMoney) {
  window.Shopify.formatMoney = (cents) => {
    const amount = Number(cents || 0) / 100;
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: window.Shopify.currency?.active || 'GBP'
    }).format(amount);
  };
}

class VariantSelector extends HTMLElement {
  connectedCallback() {
    this.variants = JSON.parse(this.dataset.variants || '[]');
    this.form = this.closest('form');
    this.idInput = this.form?.querySelector('[data-variant-id]');
    this.submit = this.form?.querySelector('[data-add-to-cart]');
    this.addEventListener('change', () => this.onChange());
  }

  onChange() {
    const selected = Array.from(this.querySelectorAll('input:checked')).map((input) => input.value);
    const variant = this.variants.find((item) => item.options.every((option, index) => option === selected[index]));
    if (!variant || !this.idInput || !this.submit) return;
    this.idInput.value = variant.id;
    this.submit.disabled = !variant.available;
    this.submit.textContent = variant.available ? `Add to Bag - ${Shopify.formatMoney(variant.price)}` : 'Sold Out';
  }
}

customElements.define('variant-selector', VariantSelector);

const qs = (selector, scope = document) => scope.querySelector(selector);
const qsa = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));

function openCart() {
  const drawer = qs('[data-cart-drawer]');
  const scrim = qs('.drawer-scrim');
  if (!drawer || !scrim) return;
  renderCart();
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  scrim.hidden = false;
}

function closeDrawers() {
  const drawer = qs('[data-cart-drawer]');
  const scrim = qs('.drawer-scrim');
  if (drawer) {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  }
  if (scrim) scrim.hidden = true;
}

async function renderCart() {
  const body = qs('[data-cart-drawer-body]');
  if (!body) return;
  const cart = await fetch('/cart.js').then((response) => response.json());
  qsa('[data-cart-count]').forEach((node) => {
    node.textContent = cart.item_count;
  });
  if (!cart.items.length) {
    body.innerHTML = '<p>Your bag is empty</p><a class="button" href="/collections/all">Shop now</a>';
    return;
  }
  body.innerHTML = `
    ${cart.items.map((item) => `
      <div class="drawer-line">
        ${item.image ? `<img src="${item.image}" alt="${item.product_title}">` : '<div></div>'}
        <div>
          <h3>${item.product_title}</h3>
          <p>${item.variant_title || ''}</p>
          <p>Qty ${item.quantity}</p>
          <strong>${Shopify.formatMoney(item.final_line_price)}</strong>
        </div>
      </div>
    `).join('')}
    <div class="drawer-summary">
      <p>Subtotal <strong>${Shopify.formatMoney(cart.total_price)}</strong></p>
      <a class="button" href="/checkout">Checkout</a>
      <a class="button button--ghost" href="/cart">View bag</a>
    </div>
  `;
}

async function quickAdd(form, submitter) {
  const button = form.querySelector('button');
  const variantInput = form.querySelector('[data-hover-variant-id]');
  if (submitter?.matches?.('[data-size-quick-add]') && variantInput) {
    variantInput.value = submitter.value;
  }
  const oldText = button?.textContent;
  if (button) {
    button.disabled = true;
    button.textContent = 'Adding';
  }
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { Accept: 'application/json' },
    body: new FormData(form)
  });
  if (!response.ok) {
    if (button) {
      button.disabled = false;
      button.textContent = oldText || 'Quick Add';
    }
    return;
  }
  if (button) {
    button.disabled = false;
    button.textContent = oldText || 'Quick Add';
  }
  openCart();
}

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  if (target.closest('[data-cart-open]')) openCart();
  if (target.closest('[data-drawer-close]')) closeDrawers();
  if (target.closest('[data-search-toggle]')) {
    const overlay = qs('[data-search-overlay]');
    if (overlay) overlay.hidden = !overlay.hidden;
  }
  if (target.closest('[data-menu-toggle]')) {
    const menu = qs('[data-mobile-menu]');
    if (menu) menu.hidden = !menu.hidden;
  }
  if (target.closest('[data-filter-toggle]')) {
    const panel = qs('[data-filter-panel]');
    if (panel) panel.classList.toggle('is-open');
  }
});

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (form.matches('[data-quick-add], .product-form')) {
    event.preventDefault();
    quickAdd(form, event.submitter);
  }
});

document.addEventListener('change', (event) => {
  const form = event.target instanceof Element ? event.target.closest('[data-sort-form]') : null;
  if (form instanceof HTMLFormElement) form.submit();
});
